export const SCALE_LIST = [25, 50, 100, 150, 200, 300, 400, 600, 800, 1000, 1500, 2000];